// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhl_tr","LeftMenu__link":"ir_b bhl_vt bhl_a bhl_rc","LeftMenu__link__icon":"ir_c"};